import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { userItemsPerListMixin } from '@/utils/vuex';
import userAccessPermissionMixin from '@/components/core/tenant/userAccessPermissionMixin';
import userListMixin from '@/components/core/tenant/userListMixin';
import compact from 'lodash/compact';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['email'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'CoreTenantUsersList',
  mixins: [userListMixin, userItemsPerListMixin, userAccessPermissionMixin],
  props: {
    userManageAccesses: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    selectedTenantId: {
      type: Number,
      required: false,
      default: null
    },
    tablePage: {
      type: Number,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      tableOptions: _objectSpread({}, defaultTableOptions),
      scopeDescencionMapping: {}
    };
  },
  computed: {
    fetchOptions: function fetchOptions() {
      return ['no-rules'];
    },
    tableLocalized: function tableLocalized() {
      return {
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
        },
        headers: compact([{
          text: this.$i18n_t('Common.lastName'),
          value: 'lastName',
          sortable: true
        }, {
          text: this.$i18n_t('Common.firstName'),
          value: 'firstName',
          sortable: true
        }, {
          text: this.$i18n_t('Common.email'),
          value: 'email',
          sortable: true
        }, {
          text: this.$i18n_t('Common.active'),
          value: 'active',
          sortable: true,
          align: 'center'
        }, this.hasUserManagePermission || this.hasImpersonatePermission ? {
          text: this.$i18n_t('Common.actions'),
          value: '',
          sortable: false,
          align: 'right'
        } : null])
      };
    }
  },
  watch: {
    tablePage: function tablePage(newVal) {
      this.tableOptions.page = newVal;
    }
  },
  created: function created() {
    var _this = this;

    this.tableOptions.page = this.tablePage || defaultTableOptions.page;
    this.tableOptions.itemsPerPage = this.savedUserItemsPerList();
    this.doFetchSessionAccessDetails().then(function () {
      return _this.fetchUsers();
    }).catch(function (e) {
      console.error('Error during user-fetch', e);
    });
  },
  methods: {
    editUser: function editUser(user) {
      this.$store.commit('app/setTablePage', this.tableOptions.page || defaultTableOptions.page);
      this.$emit('editUser', user);
    }
  }
};